const issueFieldsPrevious = [
  {
    id: "book_id",
    numeric: true,
    disablePadding: false,
    label: "Book Id",
    width: "auto",
  },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
    width: "200px",
  },
  {
    id: "author",
    numeric: false,
    disablePadding: false,
    label: "Author",
    width: "200px",
  },
  {
    id: "userid",
    numeric: true,
    disablePadding: false,
    label: "User Id",
    width: "auto",
  },
  {
    id: "return_date",
    numeric: true,
    disablePadding: false,
    label: "Return Date",
    width: "80px",
    type: "date",
  },
  {
    id: "returnByName",
    numeric: false,
    disablePadding: false,
    label: "Return By",
    width: "auto",
  },
];

export default issueFieldsPrevious;
